import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const S3StorageUploadError = BaseErrorSchema.extend({
  errorType: z.literal('S3StorageUploadError'),
  bucketName: z.string(),
  bucketRegion: z.string(),
  key: z.string(),
  errorReason: z.string(),
});

export type S3StorageUploadError = z.infer<typeof S3StorageUploadError>;
